import CrearCliente from './CrearCliente'

export default CrearCliente
